<template>
  <SideBarAsideFix/>

  <div class="content ht-100v pd-0">
    <div class="content-header">
      <div class="content-search">
        <i data-feather="search"></i>
        <input type="search" class="form-control" placeholder="Search...">
      </div>
      <nav class="nav">
        <a href="" class="nav-link"><i data-feather="help-circle"></i></a>
        <a href="" class="nav-link"><i data-feather="grid"></i></a>
        <a href="" class="nav-link"><i data-feather="align-left"></i></a>
      </nav>
    </div><!-- content-header -->

    <div class="content-body">
      <div class="container pd-x-0">

        <ol class="breadcrumb breadcrumb-style1 mg-b-10">
          <li class="breadcrumb-item">Harvest DataCenter</li>
          <li class="breadcrumb-item"><a href="#">Dashboard</a></li>
          <li class="breadcrumb-item active" aria-current="page">configurations</li>
        </ol>
        <h4 class="df-title mg-b-5-f">Configurations</h4>
        <p class="df-lead">A collection of widgets and components to use in your dashboard or application pages.</p>

        <div class="row row-xs mg-t-10">
          <div class="col-md-6 col-xl-4 mg-t-10">
            <div class="card ht-100p">
              <div class="card card-widget card-contacts">
                <div class="card-header">
                  <h6 class="mg-b-0">Newest Members</h6>
                  <nav class="nav">
                    <a href=""><i data-feather="help-circle"></i></a>
                    <a href=""><i data-feather="more-vertical"></i></a>
                  </nav>
                </div><!-- card-header -->
                <div class="card-body pd-0">
                  <ul v-for="(contact) in contacts" :key="contact.id" :id="'row-'+contact.id" class="list-group list-group-flush">
                    <li class="list-group-item">
                      <div class="avatar">
                        <span :class="getRandomColor()"> {{ getFirstString(contact.first_name) }}</span>
                      </div>
                      <div class="list-body">
                        <h6>
              <span v-if="(contact.first_name + contact.middle_name + contact.last_name).length<35">{{ contact.first_name }} {{
                  contact.middle_name
                }} {{ contact.last_name }}</span>
                          <span v-else>{{
                              (contact.first_name + ' ' + contact.middle_name + ' ' + contact.last_name).substring(0, 22) + "..."
                            }}</span>
                        </h6>
                        <p> Mobile: {{ contact.phone_number }} </p>
                      </div>
                      <nav class="nav">
                        <a :href="`/users/${contact.id}`"><i data-feather="message-square"></i></a>
                        <a :href="`/users/${contact.id}`"><i data-feather="mail"></i></a>
                        <a :href="`/users/${contact.id}`"><i data-feather="more-vertical"></i></a>
                      </nav>
                    </li>
                  </ul>
                </div><!-- card-body -->
                <div class="card-footer bg-transparent">
                  <a :href="`/users?sort=first_attendance,desc&size=15`" class="link-03 d-flex align-items-center gap-1">View All Contacts <ion-icon name="arrow-forward-outline"></ion-icon></a>
                </div><!-- card-footer -->
              </div>
            </div><!-- card -->
          </div>

          <div class="col-md-6 col-xl-4 mg-t-10">
            <div class="card card-widget card-events">
              <div class="card-header">
                <h6 class="card-title mg-b-0">Events</h6>
                <nav class="nav">
                  <a href="#"><i data-feather="help-circle"></i></a>
                  <a href="#"><i data-feather="more-vertical"></i></a>
                </nav>
              </div><!-- card-header -->
              <div class="card-body">
                <ul class="list-unstyled media-list mg-b-0">
                  <li class="media">
                    <div class="media-left">
                      <label>Sat</label>
                      <p>03</p>
                    </div>
                    <div class="media-body event-panel-green">
                      <span class="event-time">8:00am - 10:30am</span>
                      <h6 class="event-title">Web Design Workshop</h6>
                    </div>
                  </li>
                  <li class="media">
                    <div class="media-left">
                      <label>Wed</label>
                      <p>07</p>
                    </div>
                    <div class="media-body event-panel-pink">
                      <span class="event-time">10:00 - 11:00am</span>
                      <h6 class="event-title">Personal Religous Event</h6>
                    </div>
                  </li>
                  <li class="media">
                    <div class="media-left">
                      <label>Thu</label>
                      <p>08</p>
                    </div>
                    <div class="media-body event-panel-primary">
                      <span class="event-time">1:00pm - 2:00am</span>
                      <h6 class="event-title">Batch 2012 Grand Reunion</h6>
                      <p class="event-desc">Duis aute irure dolor in repre hende rit i...</p>
                    </div>
                  </li>
                  <li class="media">
                    <div class="media-left">
                      <label>Mon</label>
                      <p>23</p>
                    </div>
                    <div class="media-body event-panel-orange">
                      <span class="event-time">1:00pm - 2:00am</span>
                      <h6 class="event-title">Front-End Wizard Meetup</h6>
                    </div>
                  </li>
                  <li class="media">
                    <div class="media-left">
                      <label>Mon</label>
                      <p>23</p>
                    </div>
                    <div class="media-body event-panel-orange">
                      <span class="event-time">1:00pm - 2:00am</span>
                      <h6 class="event-title">Front-End Wizard Meetup</h6>
                    </div>
                  </li>
                </ul>
              </div><!-- card-body -->
              <div class="card-footer bg-transparent">
                <a href="" class="link-03 d-flex align-items-center gap-1">Explore More Events <ion-icon name="arrow-forward-outline"></ion-icon></a>
              </div><!-- card-footer -->
            </div><!-- card -->
          </div><!-- col -->

          <div class="col-md-6 col-xl-4 mg-t-10">
            <div class="card card-widget card-todo">
              <div class="card-header">
                <h6 class="card-title mg-b-0">To Do</h6>
                <nav class="nav">
                  <a href="#"><i data-feather="help-circle"></i></a>
                  <a href="#"><i data-feather="more-vertical"></i></a>
                </nav>
              </div><!-- card-header -->
              <ul class="list-group list-group-flush">
                <li class="list-group-item">
                  <div class="list-group-header">
                    <span class="bg-purple"></span>
                    <span class="bg-success"></span>
                    <a href="" class="link-03 mg-l-auto"><i data-feather="more-horizontal"></i></a>
                  </div>
                  <h6 class="todo-title"><a href="" class="link-01">Javascript countdown timer link</a></h6>
                  <p class="todo-date">Today, July 29, 2023</p>

                  <div class="card-progress">
                    <label class="content-label mg-b-0">Progress</label>
                    <div class="progress">
                      <div class="progress-bar wd-75p" role="progressbar" aria-valuenow="0" aria-valuemin="0" aria-valuemax="100"></div>
                    </div>
                    <label class="content-label mg-b-0">0%</label>
                  </div>

                  <div class="d-flex align-items-center justify-content-between">
                    <div class="avatar-group">
                      <div class="avatar avatar-xxs"><img src="https://placehold.co/500" class="rounded-circle" alt=""></div>
                      <div class="avatar avatar-xxs"><img src="https://placehold.co/500" class="rounded-circle" alt=""></div>
                      <div class="avatar avatar-xxs"><img src="https://placehold.co/500" class="rounded-circle" alt=""></div>
                      <a href="" class="avatar-add"><i data-feather="plus" class="svg-12"></i></a>
                    </div>
                    <span class="badge badge-warning">Javascript</span>
                  </div>
                </li>
                <li class="list-group-item">
                  <div class="list-group-header">
                    <span class="bg-primary"></span>
                    <a href="" class="link-03 mg-l-auto"><i data-feather="more-horizontal" class="svg-16"></i></a>
                  </div>
                  <h6 class="todo-title"><a href="" class="link-01">Track in HTML 5</a></h6>
                  <p class="todo-date">Today, July 29, 2023</p>

                  <div class="card-progress">
                    <label class="content-label mg-b-0">Progress</label>
                    <div class="progress">
                      <div class="progress-bar wd-50p" role="progressbar" aria-valuenow="0" aria-valuemin="0" aria-valuemax="100"></div>
                    </div>
                    <label class="content-label mg-b-0">0%</label>
                  </div>

                  <div class="d-flex align-items-center justify-content-between">
                    <div class="avatar-group">
                      <div class="avatar avatar-xxs"><img src="https://placehold.co/500" class="rounded-circle" alt=""></div>
                      <div class="avatar avatar-xxs"><img src="https://placehold.co/500" class="rounded-circle" alt=""></div>
                      <a href="" class="avatar-add"><i data-feather="plus" class="svg-12"></i></a>
                    </div>
                    <span class="badge bg-orange tx-white">HTML</span>
                  </div>
                </li>
                <li class="list-group-item">
                  <div class="list-group-header">
                    <span class="bg-primary"></span>
                    <a href="" class="link-03 mg-l-auto"><i data-feather="more-horizontal" class="svg-16"></i></a>
                  </div>
                  <h6 class="todo-title"><a href="" class="link-01">Track in HTML 5</a></h6>
                  <p class="todo-date">Today, July 29, 2023</p>

                  <div class="card-progress">
                    <label class="content-label mg-b-0">Progress</label>
                    <div class="progress">
                      <div class="progress-bar wd-50p" role="progressbar" aria-valuenow="0" aria-valuemin="0" aria-valuemax="100"></div>
                    </div>
                    <label class="content-label mg-b-0">0%</label>
                  </div>

                  <div class="d-flex align-items-center justify-content-between">
                    <div class="avatar-group">
                      <div class="avatar avatar-xxs"><img src="https://placehold.co/500" class="rounded-circle" alt=""></div>
                      <div class="avatar avatar-xxs"><img src="https://placehold.co/500" class="rounded-circle" alt=""></div>
                      <a href="" class="avatar-add"><i data-feather="plus" class="svg-12"></i></a>
                    </div>
                    <span class="badge bg-orange tx-white">HTML</span>
                  </div>
                </li>
              </ul>
              <div class="card-footer bg-transparent bd-t-0">
                <a href="" class="btn btn-block">&plus; Add Task</a>
              </div><!-- card-footer -->
            </div><!-- card -->
          </div><!-- col -->

        </div><!-- row -->




      </div><!-- container -->

    </div>

  </div>

</template>

<script>
import SideBarAsideFix from "../components/SideBarAsideFix.vue";
import footerScriptMixin from "@/mixins/footer-script";
import serviceMixin from "@/mixins/contact-service";
export default {
  name: "Configuration",
  components: {SideBarAsideFix},
  mixins: [footerScriptMixin, serviceMixin],
  watch: {},
  data() {
    return {
      contacts: [],
      colors: ['bg-info','bg-primary','bg-indigo','bg-gray-800','bg-black','bg-facebook','bg-pink','bg-teal','bg-twitter','bg-secondary']
    }
  },
  created() {
    this.footerScript();
    this.asideBarScript();
    this.loadData();
  },
  methods: {
    async loadData() {
      let url = await this.buildQueryParam(this.page, this.first_name, this.middle_name,
          this.last_name, this.email, this.birthday_month,
          this.marital_status, this.wofbi_status, this.water_baptism,
          this.service_unit, '6', 'first_attendance,desc');

      let result = await this.getContacts(url);
      if (result.data) {
        this.contacts = this.$store.state.contact_list;
      } else {
        this.contacts = [];
      }
    },

    getRandomColor() {
      return `avatar-initial rounded-circle ${this.colors[Math.floor(Math.random() * this.colors.length)]}`;
    },

    getFirstString(data) {
      return data.charAt(0).toUpperCase();
    }
  }
}
</script>

<style scoped>
@import '../../assets/css/dashforge.dashboard.css';
@import '../../assets/lib/remixicon/fonts/remixicon.css';
@import '../../assets/lib/select2/css/select2.min.css';

</style>
